// extracted by mini-css-extract-plugin
module.exports = {"root":"submenu-block_root__HyPeP","title":"submenu-block_title__zP1fe","content":"submenu-block_content__Q9Uf9"};